import { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import Icons from "../../myIcon/Icons";

export default function ServiceDetailFind() {
  const galleryRef = useRef(null);
  const [inView, setInView] = useState(false);
  const timeoutRef = useRef(null);

  const [activeIndex] = useState(null);
  const [highlightStyle, setHighlightStyle] = useState({
    top: 0,
    height: 0,
    opacity: 0,
  });

  const containerRef = useRef(null);
  const item1Ref = useRef(null);
  const item2Ref = useRef(null);
  const item3Ref = useRef(null);
  const item4Ref = useRef(null);
  const item5Ref = useRef(null);

  const allRefs = [item1Ref, item2Ref, item3Ref, item4Ref, item5Ref];

  const updateHighlight = (index, isActive = false) => {
    const el = allRefs[index].current;
    if (!el || !containerRef.current) return;
    const rect = el.getBoundingClientRect();
    const containerRect = containerRef.current.getBoundingClientRect();

    setHighlightStyle({
      top: rect.top - containerRect.top,
      height: rect.height,
      opacity: isActive ? 0 : 1,
    });
  };

  const handleMouseEnter = (index) => {
    if (index !== activeIndex) updateHighlight(index, false);
  };

  const handleMouseLeave = () => {
    if (activeIndex !== null) {
      updateHighlight(activeIndex, true);
    } else {
      setHighlightStyle((prev) => ({ ...prev, opacity: 0 }));
    }
  };


  // line effect
    useEffect(() => {
      if (!galleryRef.current) return;
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            // wait 500ms before setting inView
            const timer = setTimeout(() => setInView(true), 500);
            return () => clearTimeout(timer);
          }
        },
        {
          threshold: 0.2, // 60% visible
        }
      );

      observer.observe(galleryRef.current);

      return () => observer.disconnect();
    }, []);


  return (
    <>
    <section className="detailserv-find">
        <div className="container">
            <div className="row"> 

                <div className="col-lg-12">
                    <div className="line-heading">
                        <div ref={galleryRef} className={`lineeffect ${inView ? "showline" : ""}`}></div>
                        <span>Concept</span>
                    </div>
                </div>

                <div className="col-lg-6 col-md-6">
                    <div className="servfind-box wow animate__animated animate__slideInLeft" data-wow-duration="1.3s" data-wow-delay="0.1s">
                        <h2 className="heading">Smart solutions, crafted for modern lifestyles</h2>
                        <p>Homes, offices, and commercial spaces: Saysha’s modular interiors blend efficiency with elegance. From flexible storage systems to seamlessly integrated workspaces, every element is designed to optimize space while maintaining aesthetic harmony. Functionality meets refined design, creating versatile environments that are both practical and visually striking.</p>
                        <Link to={"/project"} className="default-btn colored-btn">Explore The Collections <Icons name="Longarrow_right"/></Link>
                    </div>
                </div>

                <div className="col-lg-6 col-md-6">
                    <p className="findserv-head">Find out more</p>

                    <div className="list-container" ref={containerRef} onMouseLeave={handleMouseLeave}>
                        <ul className="list-findserv">
                          <li ref={item1Ref} className={`list-item ${activeIndex === 0 ? "active" : ""}`}  onMouseEnter={() => handleMouseEnter(0)}>
                            <Link to={"/contact"}><img src="/image/findlist-1.webp" alt="icon"/> Book a consultation</Link>
                          </li>

                          <li ref={item2Ref} className={`list-item ${activeIndex === 1 ? "active" : ""}`}  onMouseEnter={() => handleMouseEnter(1)}>
                            <Link to={"/contact"}><img src="/image/findlist-2.webp" alt="icon"/> Request information</Link>
                          </li>

                          <li ref={item3Ref} className={`list-item ${activeIndex === 2 ? "active" : ""}`}  onMouseEnter={() => handleMouseEnter(2)}>
                            <a href="/image/Saysha_catalogue.pdf" download rel="noopener noreferrer"><img src="/image/findlist-3.webp" alt="icon"/> Download the Saysha Deck catalogue</a>
                          </li>
                        </ul>

                        <div className="highlight" style={{
                            top: highlightStyle.top,
                            height: highlightStyle.height,
                            opacity: highlightStyle.opacity,
                          }}/>
                    </div>
                </div>

            </div>
        </div>
    </section>
    </>
  );
}
